import React from "react";
import "slick-carousel";
import Hero from "../../components/hero/Hero";
import Photo1 from "../../images/DSC_0263_edit.jpg";
import ClientLogoSlider from "../../components/ClientLogoSlider/ClientLogoSlider";

function Home() {
  return (
    <>
      <Hero />

      <div className="site-main">
        <section className="ttm-row about-section clearfix">
          <div className="container">
            <div className="about-showcase">
              <div className="about-showcase__copy">
                <div className="section-title about-showcase__intro">
                  <div className="title-header">
                    <h3>Who We Are</h3>
                    <h2 className="title">
                      Our Commitment to <span>Quality</span> and{" "}
                      <span>Service</span> at BRW Contracting.
                    </h2>
                  </div>
                  <div className="title-desc">
                    <p>
                      Established in 2001, BRW is a full-service site
                      development company located in Land O&apos; Lakes,
                      Florida. We are proud to be a leader in providing
                      high-quality construction services to our customers. Our
                      primary goal is to create successful partnerships with our
                      customers and build long lasting relationships that are
                      built on integrity and trust by exceeding expectations
                      through exceptional planning and performance.
                    </p>
                  </div>
                </div>

                <div className="about-showcase__points">
                  <article className="about-point">
                    <span className="about-point__index">01</span>
                    <p>
                      BRW is a comprehensive site development and construction
                      company based in Land O&apos; Lakes, FL.
                    </p>
                  </article>

                  <article className="about-point">
                    <span className="about-point__index">02</span>
                    <p>
                      Our team has decades of experience in the construction and
                      development industry, with hundreds of successfully
                      completed projects.
                    </p>
                  </article>

                  <article className="about-point">
                    <span className="about-point__index">03</span>
                    <p>
                      We provide land clearing, earthwork, underground
                      utilities, concrete, roadway construction, paving and
                      striping, curbing, and flatwork.
                    </p>
                  </article>

                  <article className="about-point">
                    <span className="about-point__index">04</span>
                    <p>
                      We pride ourselves on dependable execution and exceeding
                      client expectations through quality work.
                    </p>
                  </article>
                </div>

                <div className="about-showcase__actions">
                  <a className="about-showcase__cta" href="/about">
                    More About Us
                    <i className="fa fa-long-arrow-right" />
                  </a>
                </div>
              </div>

              <div className="about-showcase__media">
                <div className="about-showcase__image-shell">
                  <div className="about-showcase__image-card">
                    <div className="ttm_single_image-wrapper imagestyle-two">
                      <img
                        className="img-fluid auto_size"
                        src={Photo1}
                        alt=""
                        height={546}
                        width={720}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="rightAnim"
          className="ttm-row fid-section ttm-bgimage-yes bg-img5 ttm-bg ttm-bgcolor-darkgrey clearfix"
        >
          <div className="ttm-row-wrapper-bg-layer ttm-bg-layer" />
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style2">
                      <div className="ttm-fid-icon-wrapper">
                        <i className="flaticon flaticon-renovation" />
                      </div>
                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span
                            data-appear-animation="animateDigits"
                            data-from={0}
                            data-to={23}
                            data-interval={1}
                            data-before=""
                            data-before-style="sup"
                            data-after=""
                            data-after-style="sub"
                            className="numinate"
                          >
                            23
                          </span>
                        </h4>
                        <h3 className="ttm-fid-title">Years Experience</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style2">
                      <div className="ttm-fid-icon-wrapper">
                        <i className="flaticon flaticon-building-1" />
                      </div>
                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span
                            data-appear-animation="animateDigits"
                            data-from={0}
                            data-to={550}
                            data-interval={5}
                            data-before=""
                            data-before-style="sup"
                            data-after="+"
                            data-after-style="sub"
                            className="numinate"
                          >
                            550
                          </span>
                          +
                        </h4>
                        <h3 className="ttm-fid-title">Projects</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style2">
                      <div className="ttm-fid-icon-wrapper">
                        <i className="flaticon flaticon-workers" />
                      </div>
                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span
                            data-appear-animation="animateDigits"
                            data-from={0}
                            data-to={500}
                            data-interval={5}
                            data-before=""
                            data-before-style="sup"
                            data-after="+"
                            data-after-style="sub"
                            className="numinate"
                          >
                            500
                          </span>
                          +
                        </h4>
                        <h3 className="ttm-fid-title">Team members</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="ttm-fid inside ttm-fid-with-icon ttm-fid-view-lefticon style2">
                      <div className="ttm-fid-icon-wrapper">
                        <i className="flaticon flaticon-design-team" />
                      </div>
                      <div className="ttm-fid-contents">
                        <h4 className="ttm-fid-inner">
                          <span
                            data-appear-animation="animateDigits"
                            data-from={0}
                            data-to={99}
                            data-interval={3}
                            data-before=""
                            data-before-style="sup"
                            data-after="+"
                            data-after-style="sub"
                            className="numinate"
                          >
                            99
                          </span>
                          % +
                        </h4>
                        <h3 className="ttm-fid-title">Self Performance</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section
          id="leftAnim"
          className="ttm-row mt_340 res-991-margin_top0 bg-layer-equal-height clearfix ttm-bgcolor-grey"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="section-title title-style-center_text">
                      <div className="other-title-header">
                        <h3>Keep up to date with the latest</h3>
                        <h2 className="title">
                          BRW <span>NEWS</span>
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="elfsight-app-67492891-3b7d-47dc-949f-3c648b8fa5f5" />
          </div>
        </section>

        <section className="ttm-row valuable-section ttm-bgcolor-grey clearfix">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="client-logo-showcase">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="section-title title-style-center_text client-logo-showcase__header">
                        <div className="other-title-header">
                          <h3>Trusted by leading owners and builders</h3>
                          <h2 className="title">
                            Some Of Our <span>Valued</span> Clients
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ClientLogoSlider />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default Home;
